import React, { useContext } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { AppContext } from "context/app";
import { LoginForm } from "components/Forms/Login";
import { Button } from "@pepdirect/ui/button";
import { Heading } from "@pepdirect/ui/heading";
import { SimpleHeader } from "@pepdirect/ui/SimpleHeader";
import { useCurrentUserIdQuery } from "services/graphql/generated";
import { PageRoutes } from "constants/pageRoutes";
import { BrandConfigCustomizationsImage } from "services/graphql/generated";
import st from "./signIn.module.scss";

export default function SignIn(): JSX.Element | null {
  const { tenant } = useContext(AppContext);
  const canSignUp = tenant?.capabilities.signUp.enabled;
  const fallbackUrl = tenant?.fallbackUrl || "";
  const logo =
    tenant?.brandConfig?.customizations?.images?.find(
      (img: BrandConfigCustomizationsImage) => img.name === "logoSmallUrl"
    ) || null;
  const router = useRouter();
  const { data: currentUserId, loading: currentUserIdLoading } =
    useCurrentUserIdQuery();

  if (currentUserIdLoading) return null;

  if (currentUserId?.currentUser) {
    router.push(PageRoutes.account);
    return null;
  }

  const goToCreateAccount = () => {
    const { successRedirectTo, successRedirectSite } = router.query;
    router.push({
      pathname: PageRoutes.signUp,
      query: {
        ...(successRedirectTo && { successRedirectTo }),
        ...(successRedirectSite && { successRedirectSite }),
      },
    });
  };

  return (
    <>
      <Head>
        <title>Login to {tenant?.brandConfig.title || "your account"}</title>
      </Head>
      <SimpleHeader
        logo={{ src: logo?.src || "", alt: logo?.alt || "Shop logo" }}
        fallbackUrl={fallbackUrl}
      />
      <main className={st.form}>
        <LoginForm>
          {canSignUp && (
            <div className={st.signUp}>
              <Heading level="h3" size="m">
                New{" "}
                {`${
                  tenant?.brandConfig.title
                    ? "to " + tenant?.brandConfig.title + "?"
                    : "here?"
                }`}
              </Heading>
              <Button type="tertiary" fullWidth onClick={goToCreateAccount}>
                Create an account
              </Button>
            </div>
          )}
        </LoginForm>
      </main>
    </>
  );
}
